<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ "STP Config" }}</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the current STP config." }}
      </p>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <block-cntr :btitle="'STP Global Config'" style="height: 100%">
          <div style="margin-left: 10px">
            <form class="form-horizontal" role="form">
            <div class="form-group">
              <label class="col-sm-1 control-label" for="stpswitch"
                ><b>Status</b></label
              >
              <div class="col-sm-2">
                <select class="form-control" id="stpswitch" v-model="stpEnable">
                  <option value="2">Disable</option>
                  <option value="1">Enable</option>
                </select>
              </div>
            </div>

            <div v-if="stpEnable == 1" class="form-group">
              <label class="col-sm-1 control-label" for="stpmode"><b>Mode</b></label>
              <div class="col-sm-2">
                <select class="form-control" id="stpmode" v-model="stpMode">
                  <option value="0">STP</option>
                  <option value="2">RSTP</option>
                </select>
              </div>
            </div>

            <button
              type="button"
              class="btn btn-primary"
              @click="clkApplyGlobal()"
            >
              {{ "Apply" }}
            </button>
            </form>
          </div>
        </block-cntr>
        <block-cntr :btitle="'STP Port Config'" style="height: 100%">
        <!--配置按钮-->
        <div class="form-inline">
          <span style="float: left">
            <div class="btn-group open">
              <div
                @click="clkEdit()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-edit page-tableaction"></i>
              </div>
              <div
                @click="loadStpInfo()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-refresh page-tableaction"></i>
              </div>
            </div>
          </span>
        </div>

        <table class="table table-hover table-noneborder-top">
          <thead>
            <tr>
              <th width="40px">
                <input
                  type="checkbox"
                  v-model="isSelectAll"
                  @change="changeSelectAll()"
                  id="idSelectAllIndex"
                />
                <label for="idSelectAllIndex"></label>
              </th>
              <th
                v-for="(value, key) in title"
                :key="key"
                :title="value"
              >
                {{ value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in stpTable"
              :key="row.index"
              :class="{ 'true:': true }"
            >
              <td width="40px">
                <div v-if="!row.isNew">
                  <input
                    type="checkbox"
                    v-model="row.selected"
                    :id="'idRowSelectStp' + index"
                  />
                  <label :for="'idRowSelectStp' + index"></label>
                </div>
              </td>
              <td>
                <div>{{ row.portId }}</div>
              </td>
              <td>
                <div>{{ row.stpEn }}</div>
              </td>
              <td>
                <div>{{ row.cost }}</div>
              </td>
              <td>
                <div>{{ row.priority }}</div>
              </td>
              <td>
                <div>{{ row.role }}</div>
              </td>
              <td>
                <div>{{ row.forward }}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <!--配置操作-->
        <div v-if="isShowAddTable">
          <dialog-box
            :btitle="'STP Config Edit'"
            style="min-height: 100%"
            @close="isShowAddTable = false"
            :closeButton="true"
          >
            <form class="form-horizontal" role="form">
              <div class="form-group">
                <label class="col-sm-3 control-label" for="stpenable"
                  >Stp Enable</label
                >
                <div class="col-sm-5">
                  <select
                    class="form-control"
                    id="stpenable"
                    v-model="portStpEnable"
                  >
                    <option value="2">Disable</option>
                    <option value="1">Enable</option>
                  </select>
               </div>
              </div>
              <button
                type="button"
                class="btn btn-primary"
                style="
                  margin-left: 20%;
                  min-width: 77px;
                  color: #fff;
                  background-color: #008b8b;
                  border-color: #008080;
                "
                @click="clkApplyPort()"
              >
                {{ "Apply" }}
              </button>
              <span style="margin-left: 10px">
                <button
                  type="button"
                  class="btn btn-default"
                  style="min-width: 77px"
                  @click="clkCancel()"
                >
                  {{ "Cancel" }}
                </button>
              </span>
            </form>
          </dialog-box>
        </div>
      </block-cntr>
      </div>
    </div>

    <info-box :ibox="iBox"></info-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"
import InfoBox from "./../components/InfoBox.vue"

export default {
  name: "stp",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },

  data() {
    return {
      title: {},
      isShowAddTable: false,
      isEditClik: false,
      isSelectAll: false,
      stpEnable :"1",
      stpMode: "0",
      iBox: {},
      select: [],
      portStpEnable:"2",
      stpTable: [],
    }
  },

  created() {
    this.loadStpInfo()
  },

  methods: {
    loadStpInfo() {
      get("stpinfo")
        .then((res) => {
          this.stpTable = res.data.data
          this.title    = res.data.title
          this.stpEnable = res.data.stpEnable
          this.stpMode   = res.data.stpMode
          console.log(res.data)
        })
        .catch((err) => {
          console.log(err)
        })
    },

    clkCancel() {
      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    resetField() {
        this.portStpEnable = "2"
    },

    clkApplyPort() {
      var newProfile = {}
      var portdata = []

      for (let i = 0; i < this.stpTable.length; i++) {
        if (this.stpTable[i].selected) {
            portdata.push({ port:  this.stpTable[i].portId,
                            enable: Number(this.portStpEnable)})
        }
      }
      newProfile["portdata"]= portdata
      post("stpportconfig", newProfile)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.showAlertBox("info", "Info", "Config successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
          this.loadStpInfo()
        })
        .catch((err) => {
          console.log(err)
          this.showAlertBox("critical", "error", "Post error!")
        })

      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    clkApplyGlobal() {
      var newProfile = {
         enable: Number(this.stpEnable),
         mode  : Number(this.stpMode)
      }

      post("stpconfig", newProfile)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.showAlertBox("info", "Info", "Config successful!")
            this.loadStpInfo()
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          console.log(err)
          this.showAlertBox("critical", "error", "Post error!")
        })

      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },


    clkEdit() {
      for (let i = 0; i < this.stpTable.length; i++) {
        if (this.stpTable[i].selected) {
          this.isShowAddTable = true
          this.isEditClik = true
          this.select[0] = i
          return
        }
      }
    },

    changeSelectAll() {
      for (let i = 0; i < this.stpTable.length; i++) {
        if (this.isSelectAll) {
          this.$set(this.stpTable[i], "selected", true)
        } else {
          this.$set(this.stpTable[i], "selected", false)
        }
      }
    },

    changeSelect(row) {
      console.log(row)
      if (row.selected == undefined) {
        this.$set(row, "selected", true)
      } else row.selected = !row.selected
    },

    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>
